import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IHolidayListParams,
  IHolidayListResponse,
  IHolidayDetailResponse,
  ICreateHolidayPayload,
  ICreateHolidayResponse,
  IUpdateHolidayPayload,
  IUpdateHolidayResponse,
} from '../../interface/holiday.interface';
import { IErrorResponse } from '../../interface/main.interface';
import { normalizeAxiosError } from '../../utility/axiosErrorHandler';
import holidayService from '../../services/holiday';

export const fetchHolidays = createAsyncThunk<
  IHolidayListResponse,
  IHolidayListParams,
  { rejectValue: IErrorResponse }
>('holiday/fetch-all', async (params, { rejectWithValue }) => {
  try {
    const response = await holidayService.fetchHolidays(params);
    return response;
  } catch (err) {
    return rejectWithValue(normalizeAxiosError(err, 'Failed to fetch holidays.'));
  }
});

export const fetchHolidayById = createAsyncThunk<
  IHolidayDetailResponse,
  string,
  { rejectValue: IErrorResponse }
>('holiday/fetch-by-id', async (id, { rejectWithValue }) => {
  try {
    const response = await holidayService.fetchHolidayById(id);
    return response;
  } catch (err) {
    return rejectWithValue(normalizeAxiosError(err, 'Failed to fetch holiday details.'));
  }
});

export const createHoliday = createAsyncThunk<
  ICreateHolidayResponse,
  ICreateHolidayPayload,
  { rejectValue: IErrorResponse }
>('holiday/create', async (payload, { rejectWithValue }) => {
  try {
    const response = await holidayService.createHoliday(payload);
    return response;
  } catch (err) {
    return rejectWithValue(normalizeAxiosError(err, 'Failed to create holiday.'));
  }
});

export const updateHoliday = createAsyncThunk<
  IUpdateHolidayResponse,
  { id: string; payload: IUpdateHolidayPayload },
  { rejectValue: IErrorResponse }
>('holiday/update', async ({ id, payload }, { rejectWithValue }) => {
  try {
    const response = await holidayService.updateHoliday(id, payload);
    return response;
  } catch (err) {
    return rejectWithValue(normalizeAxiosError(err, 'Failed to update holiday.'));
  }
});

export const deleteHoliday = createAsyncThunk<
  { id: string },
  string,
  { rejectValue: IErrorResponse }
>('holiday/delete', async (id, { rejectWithValue }) => {
  try {
    await holidayService.deleteHoliday(id);
    return { id };
  } catch (err) {
    return rejectWithValue(normalizeAxiosError(err, 'Failed to delete holiday.'));
  }
});

const holidayActions = {
  fetchHolidays,
  fetchHolidayById,
  createHoliday,
  updateHoliday,
  deleteHoliday,
};

export default holidayActions;
